module.exports = __webpack_public_path__ + "img/PPMP29.b7df425d.png";